<script>
export default {
  name: 'PlayButton',
  props: {
    isPlaying: Boolean,
  },
  methods: {
    onToggle() {
      this.$emit('toggle', this.isPlaying);
    }
  },
}
</script>

<template>
  <button class="play-button" v-bind:class="{'play-button--paused': isPlaying}" v-on:click="onToggle()">
    <span class="play-button__icon"></span>
  </button>
</template>

<style scoped lang="scss">
.play-button {
  width: 4rem;
  height: 4rem;
  padding: 0;
  background: var(--light);
  border-radius: 50%;
  border: 0.1rem solid var(--light);
  box-shadow: inset 0 0 0 0.1rem var(--dark);

  &:focus {
    outline: 0;
  }
}

.play-button__icon {
  display: inline-block;
  border: 0;
  background: transparent;
  box-sizing: border-box;
  width: 0;
  height: 2.5em;
  border-color: transparent transparent transparent var(--dark);
  transition: 100ms all ease;
  border-style: solid;
  border-width: 1.5em 0 1.5em 2.3em;
  transform: translateX(.35em);
}

.play-button--paused .play-button__icon {
  border-style: double;
  border-width: 0 0 0 2em;
  transform: translateX(0);
}

</style>
